import { render, staticRenderFns } from "./CurrentHoldings.vue?vue&type=template&id=6ca1d3ab&scoped=true"
import script from "./CurrentHoldings.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1d3ab",
  null
  
)

export default component.exports